import { MbeBars, MbeClose } from '@/components/icons';
import { ROUTE_PATHS } from '@/constants';
import { useDisclosure } from '@chakra-ui/hooks';
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Image,
  Link,
  useMediaQuery,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Menu } from './Menu';

export const MenuMobile: React.FC = (): JSX.Element => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { t } = useTranslation();
  const [isLargerThan768] = useMediaQuery('(min-width: 48em)');

  return (
    <>
      <IconButton
        aria-label="Open Menu mobile"
        display={{ base: 'block', md: 'none' }}
        icon={<MbeBars h={8} w={8} />}
        onClick={onOpen}
      />
      <Drawer isOpen={!isLargerThan768 && isOpen} placement="right" size="full" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="white">
          <DrawerCloseButton color="brand.red.light" top={7}>
            <MbeClose h="2rem" w="2rem" />
          </DrawerCloseButton>
          <DrawerHeader>
            <Flex alignItems="center" grow={1} minH="60px">
              <Link href="/" maxW={250}>
                <Image alt="MBE Auction" src="/images/logo.png" title="MBE" />
              </Link>
            </Flex>
          </DrawerHeader>
          <DrawerBody>
            <Menu
              color="black"
              display="flex"
              flexDirection="column"
              gap={4}
              my={24}
              onItemClick={onClose}
            />
          </DrawerBody>
          <DrawerFooter>
            <Button
              as="a"
              href={ROUTE_PATHS.manageDetails}
              variant={{ base: 'mbeSecondary', md: 'mbeSecondaryDark' }}
              w="full"
            >
              {t('LANDING.MENU.CTA')}
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
